import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Modal from 'components/Modal';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class PaymentReceiverEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      paymentReceiver: null,
    };
  }

  updatePaymentReceiver = (formName, value) => {
    this.setState({ [formName]: value });
  };

  onExit = () => {
    this.setState({ paymentReceiver: null });
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    const { whiteLabelId, doSubmit } = this.props;
    const { paymentReceiver } = this.state;

    doSubmit(whiteLabelId, { paymentReceiver: paymentReceiver.username });
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      formStatus,
    } = this.props;
    const { paymentReceiver } = this.state;

    return (
      <Modal show={show} onHide={close} bsSize="lg" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.edit_payment_receiver}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.onSubmit} method="put">
            <div className="form-group-attached">
              <FormAutocomplete
                label={messages.payment_receiver}
                name="paymentReceiver"
                onChange={this.updatePaymentReceiver}
                autocompleteType="client"
                disabled={formStatus.pending}
                returnValueObject
              />
            </div>

            <div class="m-t-20">
              <div className="text-right">
                <Button bsStyle="primary" type="submit" bsSize="lg" disabled={!paymentReceiver || formStatus.pending}>
                  <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                  {messages.save}
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.paymentReceiverEdit,
    paymentReceiver: state.data.paymentReceiver,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doSubmit: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'paymentReceiverEdit',
        `/api/whitelabels/${whiteLabelId}/paymentreceiver.json`,
        args,
        'put',
        dispatch
      );
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PaymentReceiverEdit)
);
